import { ResourceEnum } from "src/constants/constants.ts";
import type { GridSortDirection } from "@mui/x-data-grid/models/gridSortModel";

export const defaultSelectSort: Record<
  string,
  { field: string; sort: "asc" | "desc" }
> = {
  [ResourceEnum.Country]: { field: "name", sort: "asc" },
  [ResourceEnum.Currency]: { field: "iso", sort: "asc" },
  [ResourceEnum.Customer]: { field: "name", sort: "asc" },
  [ResourceEnum.Supplier]: { field: "name", sort: "asc" },
  [ResourceEnum.Owner]: { field: "company_name", sort: "asc" },
  [ResourceEnum.MarketingCompany]: { field: "name", sort: "asc" },
  [ResourceEnum.BankAccount]: { field: "name", sort: "asc" },
  [ResourceEnum.AccountingAccount]: { field: "title", sort: "asc" },
  [ResourceEnum.Attribute]: { field: "title", sort: "asc" },
  [ResourceEnum.SelectionListAttributeValue]: {
    field: "title",
    sort: "asc",
  },
  [ResourceEnum.Category]: { field: "title", sort: "asc" },
  [ResourceEnum.Condition]: {
    field: "sort",
    sort: "asc",
  },
  [ResourceEnum.CustomerGroup]: { field: "title", sort: "asc" },
  [ResourceEnum.DeliveryMethod]: { field: "title", sort: "asc" },
  [ResourceEnum.DeliveryService]: { field: "title", sort: "asc" },
  [ResourceEnum.DeliveryTariff]: { field: "title", sort: "asc" },
  [ResourceEnum.Discount]: { field: "title", sort: "asc" },
  [ResourceEnum.DocumentTemplate]: { field: "name", sort: "asc" },
  [ResourceEnum.Language]: { field: "title", sort: "asc" },
  [ResourceEnum.Manufacturer]: { field: "title", sort: "asc" },
  [ResourceEnum.PaymentMethod]: { field: "title", sort: "asc" },
  [ResourceEnum.PriceList]: { field: "title", sort: "asc" },
  [ResourceEnum.ProcessingTime]: { field: "title", sort: "asc" },
  [ResourceEnum.Product]: { field: "sku", sort: "asc" },
  [ResourceEnum.ProductGroup]: { field: "hierarchy", sort: "asc" },
  [ResourceEnum.Role]: { field: "name", sort: "asc" },
  [ResourceEnum.Unit]: { field: "title", sort: "asc" },
  [ResourceEnum.User]: { field: "name", sort: "asc" },
  [ResourceEnum.Variant]: { field: "sku", sort: "asc" },
  [ResourceEnum.VoucherSerie]: { field: "title", sort: "asc" },
  [ResourceEnum.Warehouse]: { field: "title", sort: "asc" },
  [ResourceEnum.WarehousePlace]: { field: "title", sort: "asc" },
};
export const SELECT_DEFAULT_LABEL_PROP = "title";
export const SELECT_DEFAULT_VALUE_PROP = "id";

export const defaultListSort: Record<
  string,
  Record<string, GridSortDirection>
> = {
  [ResourceEnum.AccountingPosting]: { source_document_date: "desc" },
  [ResourceEnum.Order]: { order_date: "desc" },
  [ResourceEnum.Document]: { document_date: "desc" },
  [ResourceEnum.RecommendationCampaign]: { created_at: "desc" },
  [ResourceEnum.MarketingCouponPool]: { created_at: "desc" },
  [ResourceEnum.AnlassCampaign]: { created_at: "desc" },
  [ResourceEnum.NotificationMessage]: { created_at: "desc" },
  [ResourceEnum.BankSepa]: { created_at: "desc" },
  [ResourceEnum.BankTransaction]: { date: "desc" },
  [ResourceEnum.VacantPosition]: { document_date: "desc" },
  [ResourceEnum.AccountingPostingPosition]: { document_date: "desc" },
};
